import React from 'react'
import styles from './Eror404.module.scss'

const Eror404 = () => {
   return (
      <div className={styles.error}>
         404
      </div>
   );
};
export default Eror404